import { ComponentProps } from 'lib/component-props';
import { Placeholder, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { useMemo } from 'react';
import AbrdnPlaceholders from 'components/Generic/SitecoreWrappers/AbrdnPlaceholders';
import useHelpers from 'hooks/helpers';

type GridData = {
  count: number;
  columns: number[];
};

type CustomerReviewsSectionProps = ComponentProps & {
  rendering: ComponentRendering;
};

const CustomerReviewsSection: React.FC<CustomerReviewsSectionProps> = ({ rendering }) => {
  const gridData = useMemo((): GridData => {
    const components = rendering?.placeholders?.['abrdn-customer-reviews'] || [];

    const columns = components.map((component) => Number(component.params?.size || 12));

    return {
      count: components.length,
      columns,
    };
  }, [rendering?.placeholders]);
  const { anchorId } = useHelpers(rendering);

  return (
    <section
      id={anchorId}
      data-e2e-component-uid={rendering?.uid}
      className="default-section-margin short-section"
    >
      <div className="container">
        <Placeholder name="abrdn-tiles-heading" rendering={rendering} className="mb-4" />

        <AbrdnPlaceholders
          name="abrdn-customer-reviews"
          rendering={rendering}
          className="row margin-top-row"
          gridData={gridData}
        />
      </div>
    </section>
  );
};

export default CustomerReviewsSection;
